/**
 * Search-engine and link-preview crawlers. Their renderers report an English
 * browser language, which used to make the Turkish canonical page (/) render in
 * English for Google. Crawlers skip browser-language detection and get Turkish
 * unless the URL asks for another language (?lng=en, the hreflang alternate).
 */
export const CRAWLER_USER_AGENT_PATTERN =
  /bot|crawler|spider|crawling|slurp|bingpreview|facebookexternalhit|linkedinshare|embedly|whatsapp|telegram|slack|discord/i;

/** Query parameter that selects the UI language, e.g. https://peoply.ai/?lng=en */
export const LANGUAGE_QUERY_PARAM = 'lng';

export const USER_LANGUAGE_DETECTION_ORDER = ['querystring', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'];
export const CRAWLER_LANGUAGE_DETECTION_ORDER = ['querystring'];
